import { ECathegory, EHelpType, THelp } from "../../types"
import { GAMES, gameType } from "../../utils"
import { Heading } from "../page"
import { Help } from "./Help"

type HelpsProps = {
    helps: THelp[],
    refreshUser: any,
    userCypher?: number,
    userCathegory?: ECathegory
}

export const Helps = ({ helps, refreshUser, userCypher, userCathegory }: HelpsProps) => {

    if (helps.length < 1) {
        return <></>
    }

    const helpEnabled = (help: THelp) => {
        switch (gameType()) {
            case GAMES.SIFT: return helps.filter(i => i.help).length >= help.order - 1 
            case GAMES.ZKRATKA: return help.cypher === userCypher
        }
        return false
    }

    return (
        <>
            <Heading headline='Dostupné nápovědy' weight={3 }/>
            <div className='helps'>
                {helps.map(h =>
                    <Help
                        help={h}
                        key={h.Id}
                        enabled={helpEnabled(h) }
                        refreshUser={refreshUser}
                        userCathegory={userCathegory }
                    />
                )}
            </div>
        </>
    )
}